module.exports = __webpack_public_path__ + "static/media/icon-external-link-white.9e2b7c43.svg";